/* eslint-disable react/prop-types */
import { Controller } from 'react-hook-form'
// import { Link } from 'react-router-dom'
// import { ReturnIcon } from '../../assets/icons/Return'
import { Checkbox } from '../../components/Checkbox/Checkbox'
// import ToggleSwitch from '../../components/Switch/Switch'
import { ContainerTitle, DivTitle } from '../../components/TitlePage/TitlePage'
// import { Tour } from '../../components/Tour'
// import TourUsuariosPermissoes from '../../utils/JoyRide/tourUsuariosPermissoes'
// import { phoneMask } from '../../utils/masks'
// import { DivTop } from '../PredictionDetails/PredictionDetails.style'
import { IFormInputs } from './Mapas.interface'
import {
  // Acessos,
  B,
  BtnSave,
  // Byes,
  DivAccess,
  // DivAdm,
  DivForm,
  Estados,
  Filtro,
  FormLogin,
  InputLogin,
  InputStyle,
  // LabelLSwitch,
  LabelLogin,
  PrincipalDiv,
  Search,
  Span,

  // SpanAdm,
} from './style'
import { useMapas } from './useMapas'
import { colors } from '../../theme'
import { SearchIcon } from '../../assets/icons/search'
import SelectCompanie from '../../components/MultipleSelect'
import { Loading } from '../../components/Loading/Loading'

// const Vendedores = [
//   {
//     id: 6,
//     name: 'Administrador',
//   },
//   {
//     id: 1,
//     name: 'Vendedor1',
//   },
//   {
//     id: 2,
//     name: 'Vendedor2',
//   },
//   {
//     id: 3,
//     name: 'Vendedor3',
//   },
//   {
//     id: 4,
//     name: 'Vendedor4',
//   },
//   {
//     id: 5,
//     name: 'Vendedor5',
//   },
// ]

const estadosBrasileiros = [
  { id: 1, nome: 'Acre', sigla: 'AC' },
  { id: 2, nome: 'Alagoas', sigla: 'AL' },
  { id: 3, nome: 'Amapá', sigla: 'AP' },
  { id: 4, nome: 'Amazonas', sigla: 'AM' },
  { id: 5, nome: 'Bahia', sigla: 'BA' },
  { id: 6, nome: 'Ceará', sigla: 'CE' },
  { id: 7, nome: 'Distrito Federal', sigla: 'DF' },
  { id: 8, nome: 'Espírito Santo', sigla: 'ES' },
  { id: 9, nome: 'Goiás', sigla: 'GO' },
  { id: 10, nome: 'Maranhão', sigla: 'MA' },
  { id: 11, nome: 'Mato Grosso', sigla: 'MT' },
  { id: 12, nome: 'Mato Grosso do Sul', sigla: 'MS' },
  { id: 13, nome: 'Minas Gerais', sigla: 'MG' },
  { id: 14, nome: 'Pará', sigla: 'PA' },
  { id: 15, nome: 'Paraíba', sigla: 'PB' },
  { id: 16, nome: 'Paraná', sigla: 'PR' },
  { id: 17, nome: 'Pernambuco', sigla: 'PE' },
  { id: 18, nome: 'Piauí', sigla: 'PI' },
  { id: 19, nome: 'Rio de Janeiro', sigla: 'RJ' },
  { id: 20, nome: 'Rio Grande do Norte', sigla: 'RN' },
  { id: 21, nome: 'Rio Grande do Sul', sigla: 'RS' },
  { id: 22, nome: 'Rondônia', sigla: 'RO' },
  { id: 23, nome: 'Roraima', sigla: 'RR' },
  { id: 24, nome: 'Santa Catarina', sigla: 'SC' },
  { id: 25, nome: 'São Paulo', sigla: 'SP' },
  { id: 26, nome: 'Sergipe', sigla: 'SE' },
  { id: 27, nome: 'Tocantins', sigla: 'TO' },
]
export function Mapas() {
  // const user = localStorage.getItem('usuario')
  // const usuario = user ? JSON.parse(user) : null

  const {
    // adminId,
    accessList,
    control,
    emailValidation,
    // handleGetId,
    register,
    // statusLabel,
    isLoading,
    estados,
    setEstados,

    searchCNAE,
    setSearchCNAE,
    searchPredicoes,
    setSearchPredicoes,
    searchProspects,
    setSearchProspects,
    searchDistancia,
    setSearchDistancia,
  } = useMapas()

  return (
    <>
      {/* <ContainerTitle id="saudacaoUsuariosPermissoes"> */}
      {/* <DivTop id="finalizacaoUsuarioPermissoes"> */}
      {/* <Link to="/usuarios&permissoes">
            <ReturnIcon />
          </Link> */}
      <DivTitle id="saudacaoUsuariosPermissoes" color="black" size={22}>
        <ContainerTitle>Mapa</ContainerTitle>
      </DivTitle>
      {/* </DivTop> */}
      {/* <Tour steps={TourUsuariosPermissoes} /> */}
      {/* </ContainerTitle> */}
      <PrincipalDiv>
        <form>
          <h3>Configurações do Mapa</h3>
          <DivForm>
            <FormLogin>
              <LabelLogin htmlFor="predicoes">Créditos Predições</LabelLogin>
              <InputLogin
                {...register('name')}
                id="predicoes"
                type="text"
                value={searchPredicoes}
                onChange={event => setSearchPredicoes(event.target.value)}
                required
              />
            </FormLogin>

            <FormLogin>
              <LabelLogin htmlFor="prospects">Créditos Prospects</LabelLogin>
              <InputLogin
                {...register('name', emailValidation)}
                id="prospects"
                type="text"
                value={searchProspects}
                onChange={event => setSearchProspects(event.target.value)}
                required
              />
            </FormLogin>

            {/* <FormLogin>
              <LabelLogin htmlFor="phone">Telefone</LabelLogin>
              <InputLogin
                {...register('phone')}
                id="phone"
                type="text"
                onChange={e => {
                  e.target.value = phoneMask(e.target.value)
                }}
              />
            </FormLogin> */}

            {/* <FormLogin>
              <LabelLogin htmlFor="password">Senha</LabelLogin>
              <InputLogin
                {...register('password')}
                id="password"
                type="password"
              />
            </FormLogin>

            <FormLogin>
              <LabelLogin htmlFor="confirmPassword">Confirmar Senha</LabelLogin>
              <InputLogin
                {...register('confirmPassword')}
                id="confirmPassword"
                type="password"
              />
            </FormLogin> */}
            {/* <FormLogin id="ativoInativo">
              <LabelLSwitch htmlFor="name">Situação</LabelLSwitch>
              <Controller
                name="isActive"
                control={control}
                render={({ field: { ref, ...field } }) => (
                  <ToggleSwitch id="status" label={statusLabel} {...field} />
                )}
              />
            </FormLogin> */}
          </DivForm>
          <DivForm id="cadastro">
            <FormLogin>
              <LabelLogin htmlFor="distancia">Distância (mm)</LabelLogin>
              <InputLogin
                {...register('name')}
                id="distancia"
                type="number"
                value={searchDistancia}
                onChange={event => setSearchDistancia(event.target.value)}
              />
            </FormLogin>
          </DivForm>
          {/* <Acessos>
            <label htmlFor="email">Nível de acesso</label>
            <select>
              <option hidden>.</option>
              {Vendedores.map(User => (
                <option>{User.name}</option>
              ))}
            </select>
          </Acessos> */}
          <DivAccess id="permissoesAcesso">
            <h3>CNAEs</h3>

            <Search>
              <InputStyle
                value={searchCNAE}
                onChange={event => setSearchCNAE(event.target.value)}
                // onKeyDown={handleKeyDown}
                border={colors.grey300}
                placeholder="Pesquise uma palavra-chave"
                sizeX="264px"
                sizeY="10px"
              />
            </Search>
            <Span onClick={() => ''}>
              <SearchIcon />
            </Span>
            {Object.keys(accessList).map((value: string) => (
              <Controller
                key={value}
                name={`access[${value}]` as keyof IFormInputs}
                control={control}
                render={({ field: { ref, ...field } }) => (
                  <span key={value}>
                    <Checkbox
                      top="2px"
                      type="checkbox"
                      {...field}
                      value={value}
                    />
                    <B>{accessList[value]}</B>
                  </span>
                )}
              />
            ))}
          </DivAccess>
          <h3>Estados</h3>
          <Estados>
            <Filtro>
              {isLoading ? (
                <Loading contrast={false} />
              ) : (
                <SelectCompanie
                  width
                  value={estados}
                  handle={setEstados}
                  array={estadosBrasileiros}
                />
              )}
            </Filtro>
            {/* <Button buttonType="SMALL" type="button" onClick={() => {}}>
              Aplicar
            </Button> */}
          </Estados>

          <BtnSave type="submit">Salvar</BtnSave>
          {/* <DivAdm id="permissoesAdm">
            <h3>Administrador</h3>
            <SpanAdm>
              <Checkbox
                id="admin"
                checked={adminId === 'admin'}
                onChange={handleGetId}
              />
              <Byes>Sim</Byes>
              <Checkbox
                id="not-admin"
                checked={adminId === 'not-admin'}
                onChange={handleGetId}
              />
              <b>Não</b>
            </SpanAdm>
            <div>
              <h3>Empresas</h3>
            </div>
          </DivAdm> */}
        </form>
      </PrincipalDiv>
    </>
  )
}
